import React from "react";
import UserInformationState, { UserInformationProps } from "./UserInformation.models";
import './UserInformation.scss';
import UserPlanService from "../../../services/student/UserPlanService";
import axios from "axios";
import StudentService from "../../../services/student/StudentService";
import UserInformationContentMenuImage from '../../../assest/images/golden_cup.png'
import personalContentMenuImage from '../../../assest/images/card-image/ItemAvatar02.png'
import educationContentMenuImage from '../../../assest/images/card-image/ItemAvatar03.png'
import systemContentMenuImage from '../../../assest/images/card-image/ItemAvatar04.png'
import UserInformationModal from "../user-information-modal/UserInformationModal";
import { StudentGeneralInformationView } from "../../../models/views/identity/StudentGeneralInformationView ";
import { NavLink } from "react-router-dom";
export default class UserInformation extends React.PureComponent<UserInformationProps, UserInformationState> {
    userPlanService: UserPlanService;
    studentService: StudentService;

    constructor(props: any) {
        super(props);
        this.studentService = new StudentService();
        this.userPlanService = new UserPlanService();
        this.state = { showModal: false, coachingRemainingDays: 0, education: {}, personal: {}, studentStatus: '', system: {}, version: '' };
    }

    componentDidMount = () => {
        this.getStatus();
        this.getCoachingRemainingDays();
        this.getVersion();
    }

    about = () => {
        // window.location.href = `/About`;
    }

    getStatus = () => {
        let self = this;
        let scope = this.state;
        self.studentService.getStudentInformation().then(function (response) {
            if (response.status === 200) {
                let data: StudentGeneralInformationView = response.data;
                var status = "";
                switch (data.system.status) {
                    case 0:
                        status = "مهمان";
                        break;
                    case 1:
                        status = "ثبت نامی";
                        break;
                    case 2:
                        status = "ثبت اولیه";
                        break;
                    case -1:
                        status = "بایگانی";
                        break;
                    case -10:
                        status = "حذفی";
                        break;
                }

                self.setState({ personal: data.personal, system: data.system, education: data.education, studentStatus: status });
            }
        });

        if (scope.system.assistantName !== null && scope.system.assistantName !== undefined && scope.system.assistantName !== '')
            self.setState((prevState) => {
                return { system: { ...prevState.system, assistantName: '-' } }
            });

        if (scope.system.supporterName !== null && scope.system.supporterName !== undefined && scope.system.supporterName !== '')
            self.setState((prevState) => {
                return { system: { ...prevState.system, supporterName: '-' } }
            });

        if (scope.education.school !== null && scope.education.school !== undefined && scope.education.school !== '')
            self.setState((prevState) => {
                return { education: { ...prevState.education, school: '-' } }
            });


    }

    getVersion = () => {
        let self = this;
        axios({
            method: 'get',
            url: 'version.json',
            baseURL: '/',
        })
            .then(response => {
                if (response.data.version !== self.state.version) {
                    self.setState({ version: response.data.version });
                }
            });
    }

    getCoachingRemainingDays = () => {
        let self = this;
        self.userPlanService.getCoachingRemainingDays().then(function (response) {

            self.setState({ coachingRemainingDays: response });
        });
    }

    logOut = () => {
        delete axios.defaults.headers.common['Authorization'];
        localStorage.removeItem("access_token");
    }

    getHomePage = () => {
        window.location.href = `/`;
    }

    reloadInfo = () => {
        let self = this;

        self.studentService.getStudentInformation().then(function (response) {
            if (response.status === 200) {
                let data: StudentGeneralInformationView = response.data;
                self.setState({ personal: data.personal, system: data.system, education: data.education });
            }
        });
    }

    openModal = () => {
        let self = this;

        self.setState({ showModal: true })
    }

    closeModal = () => {
        let self = this;

        self.setState({ showModal: false })
    }

    onSubmitHandle = () => {
        let self = this;
        self.getStatus();
        self.reloadInfo();
    }

    render(): React.ReactNode {

        let { showModal, coachingRemainingDays, personal, education, system, studentStatus } = this.state;


        let contentMenu;
        if (coachingRemainingDays > 0) {
            contentMenu = (<>
                <div className="col-12 content-menu-image-area" >
                    <div className="row" >
                        <img src={UserInformationContentMenuImage} alt="user information content menu logo" width="120" />
                    </div>
                </div>
                <div className="col-12 content-menu-coaching-area" >
                    <label>تعداد روز های باقی مانده از طرح کوچینگ شما </label>
                    <label>{coachingRemainingDays} روز می باشد</label>
                </div>
            </>);
        }
        else
            contentMenu = (<></>);

        let personalContentMenu = (<>
            <div className="col-12">
                <div className="tk-card">
                    <div className="card-icon">
                        <img src={personalContentMenuImage} alt="personal content menu" />
                    </div>
                    <div className="card-title">
                        <label>اطلاعات فردی</label>
                    </div>
                    <div className="col-12 user-info">
                        <div className="tk-inline">
                            <div className="col-6 notspace">
                                <label>نام کاربری (کدملی)</label>
                            </div>
                            <div className="col-6 notspace info">
                                <label>{personal.userName}</label>
                            </div>
                        </div>
                        <div className="tk-inline">
                            <div className="col-6 notspace">
                                <label>نام</label>
                            </div>
                            <div className="col-6 notspace info">
                                <label>{personal.firstName}</label>
                            </div>
                        </div>
                        <div className="tk-inline">
                            <div className="col-6 notspace">
                                <label>نام خانوادگی</label>
                            </div>
                            <div className="col-6 notspace info">
                                <label>{personal.lastName}</label>
                            </div>
                        </div>
                        <div className="tk-inline">
                            <div className="col-6 notspace">
                                <label>تاریخ تولد</label>
                            </div>
                            <div className="col-6 notspace info">
                                <label>{personal.birthday}</label>
                            </div>
                        </div>
                        <div className="tk-inline">
                            <div className="col-6 notspace">
                                <label>شماره موبایل</label>
                            </div>
                            <div className="col-6 notspace info">
                                <label>{personal.phoneNumber}</label>
                            </div>
                        </div>
                        <div className="tk-inline">
                            <div className="col-12 notspace personal-content-menu-buttons-area" >
                                <button className="btn btn-outline-primary full-width" onClick={this.openModal}>ویرایش اطلاعات</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>);

        let educationContentMenu = (<>
            <div className="col-12">
                <div className="tk-card">
                    <div className="card-icon">
                        <img src={educationContentMenuImage} alt="education content menu" />
                    </div>
                    <div className="card-title">
                        <label>اطلاعات تحصیلی</label>
                    </div>
                    <div className="col-12 user-info">
                        <div className="tk-inline">
                            <div className="col-6 notspace">
                                <label>رشته‌ی تحصیلی</label>
                            </div>
                            <div className="col-6 notspace info">
                                <label>{education.fieldTitle}</label>
                            </div>
                        </div>
                        <div className="tk-inline">
                            <div className="col-6 notspace">
                                <label>پایه‌ی تحصیلی</label>
                            </div>
                            <div className="col-6 notspace info">
                                <label>{education.baseTitle}</label>
                            </div>
                        </div>
                        <div className="tk-inline">
                            <div className="col-6 notspace">
                                <label>مدرسه </label>
                            </div>
                            <div className="col-6 notspace info">
                                <label>{education.school}</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>);

        let systemContentMenu = (<>
            <div className="col-12">
                <div className="tk-card">
                    <div className="card-icon">
                        <img src={systemContentMenuImage} alt="system content menu" />
                    </div>
                    <div className="card-title">
                        <label> اطلاعات سیستمی</label>
                    </div>
                    <div className="col-12 user-info">
                        <div className="tk-inline">
                            <div className="col-6 notspace">
                                <label>مشاور</label>
                            </div>
                            <div className="col-6 notspace info">
                                <label>{system.assistantName}</label>
                            </div>
                        </div>
                        <div className="tk-inline">
                            <div className="col-6 notspace">
                                <label>پشتیبان</label>
                            </div>
                            <div className="col-6 notspace info">
                                <label>{system.supporterName} </label>
                            </div>
                        </div>
                        <div className="tk-inline">
                            <div className="col-6 notspace">
                                <label>وضعیت</label>
                            </div>
                            <div className="col-6 notspace info">
                                <label>{studentStatus}</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>);

        return (<>

            {/* <div className="profile-header user-information-area">
                <div className="col-12 notspace">
                    <div className="tk-inline">
                        <div className="col-6 notspace">
                            <div className="title">
                                <label>پروفایل</label>
                            </div>
                        </div>
                        <div className="col-6 notspace">
                            <div className="close-icon">
                                <a style={{ color: "white" }} className="mdi mdi-close" ></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div> */}

            <div className="content-menu user-information-area px-4">
                <div className="dropdown-list">
                    {contentMenu}
                    {personalContentMenu}
                    {educationContentMenu}
                    {systemContentMenu}
                    <div className="col-12 log-out">
                        <NavLink to={"/Login"}>
                            <button className="btn btn-danger" onClick={this.logOut}>خروج از حساب کاربری </button>
                        </NavLink>
                    </div>
                    <div className="version-box-area">
                        <label>v{this.state.version} - 2022© Barandehsaz</label>
                    </div>
                </div>
            </div>


            <UserInformationModal AfterHandle={this.onSubmitHandle} showModal={showModal} closeModal={this.closeModal} />
        </>)
    }
}